export default __webpack_public_path__ + "static/media/rabbit30.0df28486.gif";